import { useGetApiAdministrationCompaniesCompanyIdWalletTypes } from '@/api/generated/administrator-user/administrator-user'
import { useGetApiCompaniesWalletTypes } from '@/api/generated/company-management-user/company-management-user'
import type { WalletTypeResponse } from '@/api/model'

/**
 * The company's wallet types. Wallet types are per-company data, and the two endpoints differ in
 * how they resolve the company: the CMU one takes it from the token, the administration one from
 * the route. Pass `companyId` in admin scope, omit it in CMU scope — only the matching query runs.
 */
export function useWalletTypes(companyId?: number): {
  walletTypes: WalletTypeResponse[]
  isLoading: boolean
} {
  const isAdminScope = companyId != null

  const companyQuery = useGetApiCompaniesWalletTypes({}, { query: { enabled: !isAdminScope } })
  const administrationQuery = useGetApiAdministrationCompaniesCompanyIdWalletTypes(companyId ?? 0, {}, {
    query: { enabled: isAdminScope },
  })

  const query = isAdminScope ? administrationQuery : companyQuery

  return {
    walletTypes: query.data?.data ?? [],
    isLoading: query.isLoading,
  }
}
